export var EntityNames = {
    PushNotification: "msdynmkt_pushnotification",
    Sms: "msdynmkt_sms",
    Email: "msdynmkt_email"
};
